import { CopyObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { GetParametersCommand, SSMClient } from '@aws-sdk/client-ssm';
import { fetchAuthSession } from 'aws-amplify/auth';

export async function copyDocFromInternalToCustomer({ internalDocPath, customerDocPath, customerDocName }) {
  const { credentials } = await fetchAuthSession();
  const s3Client = new S3Client({
    region: 'us-east-1',
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    }
  });
  const ssmClient = new SSMClient({
    region: 'us-east-1',
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    }
  });

  // v3's send() rejects where the v2 callback resolved undefined on error. Swallow it so an
  // SSM failure still falls through to the copy and returns { success: false } as it did before.
  const getParametersResponse = await ssmClient
    .send(
      new GetParametersCommand({
        Names: ['POLICY_DOCS_S3_BUCKET'],
        WithDecryption: true
      })
    )
    .catch(() => undefined);

  const bucket = getParametersResponse && getParametersResponse.Parameters && getParametersResponse.Parameters[0].Value;
  try {
    const data = await s3Client.send(
      new CopyObjectCommand({
        Bucket: bucket,
        CopySource: `${bucket}/${internalDocPath}`,
        Key: `${customerDocPath}/${customerDocName}`
      })
    );
    return { data, success: true };
  } catch (err) {
    console.log(err);
    return { success: false };
  }
}
